import { render, staticRenderFns } from "./CatalogeList.vue?vue&type=template&id=2d33e58e&scoped=true"
import script from "./CatalogeList.vue?vue&type=script&lang=js"
export * from "./CatalogeList.vue?vue&type=script&lang=js"
import style0 from "./CatalogeList.vue?vue&type=style&index=0&id=2d33e58e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d33e58e",
  null
  
)

export default component.exports